import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=0fcf82ba&scoped=true"
import script from "./contactInfo.vue?vue&type=script&lang=js"
export * from "./contactInfo.vue?vue&type=script&lang=js"
import style0 from "./contactInfo.vue?vue&type=style&index=0&id=0fcf82ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf82ba",
  null
  
)

export default component.exports